<h2 mat-dialog-title>Transport Jobs Report</h2>

<mat-dialog-content>
  <div class="flex flex-col justify-start md:py-8 gap-y-2 md:gap-y-4" [formGroup]="form">
    <!-- Date range fields -->
    <div class="flex flex-col md:flex-row md:gap-x-4 gap-y-2 md:gap-y-0">
      <mat-form-field class="w-full md:w-2/3">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="from">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-full md:w-1/3">
        <mat-label>From Time</mat-label>
        <input matInput type="time" formControlName="fromTime">
      </mat-form-field>
    </div>

    <div class="flex flex-col md:flex-row md:gap-x-4 gap-y-2 md:gap-y-0">
      <mat-form-field class="w-full md:w-2/3">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="to">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-full md:w-1/3">
        <mat-label>To Time</mat-label>
        <input matInput type="time" formControlName="toTime">
      </mat-form-field>
    </div>

    <!-- Assigned To field -->
    <mat-form-field class="w-full">
      <mat-label>Assigned To</mat-label>
      <mat-select formControlName="assignedTo">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let user of users$ | async" [value]="user.id">
          {{ user.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="generateReport()">
    Run Report
  </button>
</mat-dialog-actions>